import DiffViewer from "common/ui/DiffViewer";
import MachineSearchService from "components/MachineSearchService";
import RequestSoftware from "components/RequestSoftware";
import AddComment from "containers/AddComment";
import AddMachine from "containers/AddMachine";
import AddUser from "containers/AddUser";
import CompleteService from "containers/CompleteService";
import DeleteModal from "containers/DeleteModal";
import EditComment from "containers/EditComment";
import EditMachine from "containers/EditMachine";
import EditUser from "containers/EditUser";
import GeneratePin from "containers/GeneratePin";
import SoftwareInfoModal from "containers/SoftwareInfoModal";
import UploadLog from "containers/UploadLog";
import UploadSoftware from "containers/UploadSoftware";
import EditSoftware from "containers/EditSoftware";

function ModalProvider() {
  return (
    <>
      <GeneratePin />
      <CompleteService />
      <MachineSearchService />
      <RequestSoftware />
      <DiffViewer />
      <AddMachine />
      <AddComment />
      <EditMachine />
      <EditComment />
      <AddUser />
      <EditUser />
      <UploadLog />
      <DeleteModal />
      <SoftwareInfoModal />
      <UploadSoftware />
      <EditSoftware />
    </>
  );
}

export default ModalProvider;
